import allPass from "./allPass";
import compose from "./compose";
import eqProps from "./eqProps";
import map from "./map";

const eqPropsAll = compose(allPass, map(eqProps));

export default eqPropsAll;
